<template>
    <div class="row">
      <div class="col-lg-12">
        <div class="table-responsive">
            <table class="table table-hover">
              <thead>
              <tr>
                <th>Action</th>
                <th>Message</th>
                <th>Time</th>
              </tr>
              </thead>
              <tbody>
                <tr v-for="info in userLogInfo" :key="info.id">
                  <td>
                    <i class="fas fa-user"></i>
                    {{ info.action }}
                  </td>
                  <td>
                    {{ info.message }}
                  </td>
                  <td>{{ info.time | aTime('from') }}</td>
                </tr>
              </tbody>
            </table>
          </div>
      </div>
    </div>
</template>
<script>
import axios from 'axios'
export default {
  data () {
    return {
      userLogInfo: []
    }
  },
  mounted () {
    this.getUserData(this.$route.params.id)
  },
  methods: {
    async getUserData (userId) {
      try {
        let response = await axios.get('/user/' + userId + '/actions')
        this.userLogInfo = response.data
      } catch (e) {
        this.$toastr.error(e, 'Error fetching user data')
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/User/Tabs/UserLog.vue